import { Card, Col, List, Row, Typography } from "antd";
import { useLottie } from "lottie-react";
import { useState } from "react";
import { CheckOutlined } from "@ant-design/icons";
import animationData from "../../../assets/json/Era.json";
// import "./textSqlHomepage.css";
import Qn1IMG from "../../../assets/question-images/cmp1.png";
import Qn2IMG from "../../../assets/question-images/cmp2.png";
import Qn3IMG from "../../../assets/question-images/cmp3.png";

const { Title } = Typography;

export const TextSqlHomePage = ({ onCardSelect }) => {
  const [selectedCard, setSelectedCard] = useState(null);

  const options = {
    animationData: animationData,
    loop: true,
  };

  const { View, setSpeed } = useLottie(options, {
    width: "inherit",
    height: "13vh",
  });
  setSpeed(3);

  const data = [
    { question: "Wire", image: Qn1IMG },
    { question: "PG", image: Qn2IMG },
    { question: "InstaCollect", image: Qn3IMG },
  ];

  const handleCardClick = (question) => {
    setSelectedCard(question);
    onCardSelect(question);
  };

  return (
    <div className="homepage">
      <Row align="middle" className="logo-show-home">
        <Col>
          <Row align="middle">
            <Col span={6}>{View}</Col>
            <Col span={18}>
              <Title className="logo-era-text">BuzzReports</Title>
            </Col>
          </Row>
          <Row justify="center">
            <Title level={3} className="logo-subtitle-text">
              Easebuzz Text To Sql
            </Title>
          </Row>
        </Col>
      </Row>
      <Row className="bits-qa" justify="center">
        <ListCards
          data={data}
          handleCardClick={handleCardClick}
          selectedCard={selectedCard}
        />
      </Row>
    </div>
  );
};

const ListCards = ({ data, handleCardClick, selectedCard, className }) => {
  return (
    <List
      grid={{ gutter: 24, xs: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 4 }}
      className={className}
      dataSource={data}
      renderItem={(item) => (
        <List.Item className="list-cards">
          <Card
            className={`questions-cards ${selectedCard === item.question ? "selected-card" : ""}`}
            onClick={() => handleCardClick(item.question)}
            hoverable
            style={{
              transition: "transform 0.3s, box-shadow 0.3s",
              position: "relative",
              cursor: "pointer",
            }}
            bodyStyle={{ padding: "12px" }}
          >
            <Title className="questions-cards-text">{item.question}</Title>
            <img
              className="questions-cards-img"
              alt={`${item.question}-img`}
              src={item.image}
            />
            {selectedCard === item.question && (
              <CheckOutlined
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  color: "green",
                  fontSize: "20px"
                }}
              />
            )}
          </Card>
        </List.Item>
      )}
    />
  );
};
